"use strict";

import jQuery from 'jquery';

/**
 * @typedef gc.gis.widget.GCSplitButtonOption
 * @type {Object}
 * @property {string} label Angezeigter Text (kann auch ein HTML-Fragment sein)
 * @property {*} value primitiver Wert
 * @property {string} [icon] Optionales Icon
 * @property {boolean} [separator=false] Trennstrich
 */

/**
 * @classdesc
 * Split-Button-Widget (Button mit einer kombinierten Auswahlliste).
 *
 * @class
 * @extends gc.gis.widget.GCItem
 * @memberof gc.gis.widget
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {string} options.id HTML-ID dieses Widgets
 * @param {string} options.target HTML-ID des Zielkontainers
 * @param {number} [options.order] optionaler Anordnungsindex
 * @param {string} [options.className=''] CSS-Klasse(n) für das Element
 * @param {string} [options.containerClassName=''] CSS-Klasse(n) für den Container
 * @param {gc.gis.widget.GCSplitButtonOption[]} [options.options] Liste von Elementen zur Auswahl.
 * @param {function} [options.click] Ereignis, welches beim Klick auf den Button ausgeführt wird
 * @param {gc.gis.action.GCAbstractAction} [options.action] Aktion, die beim Klick auf den Button ausgeführt wird
 * @param {function} [options.change] Ereignis, welches beim Wechsel der Auswahloption ausgeführt wird
 * @param {gc.gis.action.GCAbstractAction} [options.actionChange] Ereignis, welches beim Wechsel der Auswahloption
 *                  ausgeführt wird
 */
gc.gis.widget.GCSplitButton = function (options)
{
	gc.gis.widget.GCItem.call(this, options);

	/**
	 * @type {gc.gis.widget.GCSplitButtonOption[]}
	 */
	this._options = options.options || [];
	this._change = options.change;
	this._actionChange = options.actionChange;

	this._defaultOption = this._options.length > 0 ? this._options[0] : {label: ' ', value: ''};
	this._value = this._defaultOption.value;

	// TODO Button implementieren (https://getbootstrap.com/docs/3.3/components/#btn-dropdowns)

};
gc.gis.widget.GCSplitButton.prototype = Object.create(gc.gis.widget.GCItem.prototype);

/**
 * Liefert den aktuellen Wert das Buttons.
 *
 * @return {*}
 */
gc.gis.widget.GCSplitButton.prototype.getValue = function()
{
	return this._value;
};

/**
 * Setzt die Aktion, die beim Wechsel der Auswahloption ausgeführt wird.
 *
 * @method
 * @public
 * @param {{gc.gis.action.GCAbstractAction}} action
 */
gc.gis.widget.GCSplitButton.prototype.setActionChange = function(action)
{
	this._actionChange = action;
};

/**
 * @inheritdoc
 */
gc.gis.widget.GCSplitButton.prototype._render = function()
{
	var html;

	// Container
	this.element = jQuery('<div>', {
		'class': 'gc-widget gc-widget-item btn-group'
			+ (this.containerClassName ? ' ' + this.containerClassName : '')
	});

	// Button
	html = '<span class="gc-icon'
		+ (this._defaultOption.icon ? ' ' + this._defaultOption.icon : '') + '"></span>'
		+ '<span class="gc-widget-label-text">' + this._defaultOption.label + '</span>';

	this.element_control = jQuery('<button>', {
		class: 'gc-button gc-widget-label btn btn-default'
			+ (this.className ? '' + this.className : '')
			+ (this.tooltip ? ' gc-widget-tooltip' : ''),
		title: this.tooltip ? this.tooltip : this._defaultOption.label,
		html: html
	});
	this.element.append(this.element_control);

	// DropDown-Button
	this.element_control_dropdown = jQuery('<button>', {
		class: 'gc-button gc-widget-label btn btn-default dropdown-toggle',
		'data-toggle': 'dropdown',
		'aria-haspopup': true,
		html: '<span class="caret"></span><span class="gc-widget-label-text">&nbsp;</span>'
	});
	this.element.append(this.element_control_dropdown);

	if (this.tooltip)
	{
		this.element_control.attr('data-toggle', 'tooltip');
		gc.gis.iface.ui.tooltip(this.element_control);
	}

	// DropDown-Options
	this.element.append(this._renderOptions());

	// Events binden
	this._initEventsButton();
	this._initEventsDropdown();

	return this.element;
};

/**
 * Rendert die Optionen für den DropDown des Split-Buttons.
 *
 * @return {jQuery}
 * @private
 */
gc.gis.widget.GCSplitButton.prototype._renderOptions = function()
{
	var i, ii, option, option_element, option_content;
	var options_element = jQuery('<ul>', {
		class: 'dropdown-menu',
		role: 'menu'
	});

	for (i = 0, ii = this._options.length; i < ii; i++)
	{
		option = this._options[i];
		if (option.separator === true)
		{
			option_element = jQuery('<li>', {
				role: 'separator',
				class: 'divider'
			});
		}
		else
		{
			option_content = jQuery('<a>', {
				href: '#'
			});
			if (option.icon)
			{
				option_content.append(jQuery('<span>', {
						class: 'gc-icon ' + option.icon
					})
				);
			}
			option_content.append(jQuery('<span>', {
					class: 'gc-widget-label-text ',
					text: option.label
				})
			);

			option_element = jQuery('<li>', {});
			option_element.append(option_content);
			option_element.data(option);
		}
		options_element.append(option_element);
	}

	return options_element;
};

/**
 * Initialisiert die Events des Buttons.
 *
 * @private
 */
gc.gis.widget.GCSplitButton.prototype._initEventsButton = function()
{
	var self = this;

	// Klick auf den Button
	this.element_control.click(function (evt) {
		evt.preventDefault();
		try {
			if (self.action)
			{
				self.action.execute(self);
			}
			if (typeof self.click === 'function')
			{
				self.click.call(self, evt, self);
			}
		}
		catch (err)
		{
			gc.gis.iface.log.error(self, err);
		}
		jQuery(this).blur();
	});
};

/**
 * Initialisiert die Events des Dropdown.
 *
 * @private
 */
gc.gis.widget.GCSplitButton.prototype._initEventsDropdown = function()
{
	var self = this;

	// Klick auf ein Auswahlfeld
	this.element.find('ul.dropdown-menu > li:not(.divider)').click(function (evt) {
		evt.preventDefault();

		var element = jQuery(this);
		if (element.data().value !== self._value)
		{
			self._value = element.data().value;
			self._updateButton();

			try
			{
				if (self._actionChange)
				{
					self._actionChange.execute(self);
				}
				if (typeof self._change === 'function')
				{
					self._change.call(self, evt, self);
				}
			}
			catch (err)
			{
				gc.gis.iface.log.error(self, err);
			}
		}
	});
};

/**
 * Aktualisiert den Button anhand des aktuellen Werts.
 *
 * @private
 */
gc.gis.widget.GCSplitButton.prototype._updateButton = function()
{
	var self = this;

	this._options.some(function (option) {
		if (option.value === self._value)
		{
			self.element_control.find('.gc-icon')
				.removeClass()
				.addClass('gc-icon' + (option.icon ? ' ' + option.icon : ''));
			self.element_control.find('.gc-widget-label-text').html(option.label);
			return true;
		}

		return false;
	});
};